<template>
   <div id="flight-informations-wrapper" :class="data == false ? 'data-mask' : ''">
      <span class="section-title">{{ $t("orderDetailPage_flightInformation") }}</span>

      <div class="flight-container" v-for="(flight, index) in data" :key="index">
         <section class="flight-info-board">
            <h2>{{ index + 1 + ". " + $t("flightOrderDetail_txtFlight") }}</h2>
            <span class="flight-color masked-background-dark" :style="{ 'background-color': $options.filters.airlineColor(flight.segments[0].marketingAirline) }"></span>
         </section>
         <div class="segment-wrapper">
            <div class="segment-container" v-for="(segment, segindex) in flight.segments" :key="segindex">
               <section class="segment-informations masked-background">
                  <span class="segment-color masked-background-dark" style="background-color: rgb(230, 41, 43)"></span>
                  <div class="segment-informations-inner-wrapper">
                     <div class="departure">
                        <span class="airport-name-abbr masked">{{ segment.departureAirportCode }}</span>
                        <span class="airport-name-full masked">{{ segment.departureAirportName }}</span>
                        <span class="flight-date masked">
                           {{ segment.departureDateTime | fullDateFormat }}
                           {{ segment.departureDateTime | TimeFormat }}
                        </span>
                        <span class="flight-date masked">
                           {{ segment.departureDateTime | onlyDayFullName }}
                        </span>
                     </div>
                     <div class="flight-info">
                        <img :src="`${$constants.cdn}/airline_34x34/${segment.marketingAirline}.svg`" @error="$event.target.src = `${$constants.cdn}/airline_34x34/00.svg`" alt="" class="masked-img" />
                        <span class="flight-code masked">{{ segment.flightNumber }}</span>

                        <span class="flight-operated-airline masked" v-if="segment.marketingAirlineName != segment.operatingAirlineName">
                           {{ $t("flightCard_operatedBy") }} {{ segment.operatingAirlineName }}
                        </span>
                     </div>
                     <div class="arrival">
                        <span class="airport-name-abbr masked">{{ segment.arrivalAirportCode }}</span>
                        <span class="airport-name-full masked">{{ segment.arrivalAirportName }}</span>
                        <span class="flight-date masked">
                           {{ segment.arrivalDateTime | fullDateFormat }}
                           {{ segment.arrivalDateTime | TimeFormat }}
                        </span>
                        <span class="flight-date masked">
                           {{ segment.arrivalDateTime | onlyDayFullName }}
                        </span>
                     </div>
                  </div>

                  <div class="segment-extra-informations-inner-wrapper">
                     <section class="segment-extra-informations-inner-wrapper-upper">
                        <div class="info-box" v-if="hasBrandSsrs(flight.flight.brandSsrs)">
                           <span class="info-title">{{ $t("flightInformationsComponent_lblBrandName") }}</span>
                           <span class="info-content masked brand-ssr-toggler" @click="Object.keys(flight.flight.brandSsrs).length > 0 && (showBrandSsrs = !showBrandSsrs)">
                              {{ handlerBrandNameViewer(segment.brandName) }}
                              <div v-if="Object.keys(flight.flight.brandSsrs).length > 0">
                                 <i class="gts-icon icon-arrow icon-xs" :class="showBrandSsrs ? 'down' : 'up'"></i>
                              </div>
                           </span>
                        </div>

                        <div class="info-box">
                           <span class="info-title">{{ $t("flight_flightClass") }}</span>
                           <span class="info-content masked">{{ segment.flightClass }}</span>
                        </div>
                        <div class="info-box">
                           <span class="info-title">{{ $t("flight_operatingAirline") }}</span>
                           <span class="info-content masked">{{ segment.operatingAirlineName ? segment.operatingAirlineName : "-" }}</span>
                        </div>
                     </section>
                     <section class="segment-extra-informations-inner-wrapper-footer">
                        <!-- <span class="brand-ssr-informations-toggler" @click="showBrandSsrs = !showBrandSsrs">Show Brands</span> -->
                        <transition name="fade" mode="in-out">
                           <ul class="brand-ssr-informations" v-if="showBrandSsrs">
                              <template v-for="(ssr, ssrKey, ssrIndex) in flight.flight.brandSsrs">
                                 <li :key="ssrIndex">
                                    <i class="gts-icon icon-included icon-xs" v-if="ssr == 1"></i>
                                    <i class="gts-icon icon-excluded icon-xs" v-else></i>

                                    <span> {{ ssrKey }}</span>
                                 </li>
                              </template>
                           </ul>
                        </transition>
                     </section>
                  </div>
               </section>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "FlightInformations",
   props: {
      data: [Array, Object],
   },
   data() {
      return {
         showBrandSsrs: false,
      };
   },

   methods: {
      hasBrandSsrs(brandSsrs) {
         return Object.keys(brandSsrs || {}).length > 0;
      },
      handlerBrandNameViewer(brandName) {
         if (brandName) {
            return brandName.replace(/<[^>]*>/g, "");
         } else {
            return "-";
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.brand-ssr-informations {
   margin-top: 0.5rem;
   background-color: #fff;
   padding: 0.5rem;
   border-radius: 0.5rem;
   // position: absolute;

   // border: 2px solid #33b8ff !important;
   // color: #33b8ff;
   // max-width: 300px;

   // background-color: #e7f7ff;

   li {
      font-size: var(--small);

      display: flex;
      // align-items: center;
      i {
         margin-top: 0.125rem;
         flex-shrink: 0;
         transform: scale(0.8);
      }
      span {
         margin-left: 0.5rem;
      }
      // color: #33b8ff !important;
      // font-weight: 500;
   }
}
#flight-informations-wrapper {
   .flight-container {
      display: flex;
      flex-direction: column;
      margin-bottom: 1.5rem;

      @media (min-width: 576px) {
         flex-direction: row;
      }
      .flight-info-board {
         border-radius: 10px;
         display: flex;
         position: relative;
         overflow: hidden;
         flex-grow: 2;
         min-width: 45px;
         border: 1px solid #cccccc;

         h2 {
            writing-mode: horizontal-tb;
            text-orientation: unset;
            transform: rotate(0);
            text-align: center;
            font-size: var(--large);
            font-weight: 600;
            margin-left: 0.75rem !important;
            margin-right: 0.75rem !important;
            padding: 0.5rem 0;
            @media (min-width: 576px) {
               padding: 0;
               writing-mode: tb;
               transform: rotate(180deg);
            }
         }
         .flight-color {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            display: inline-block;
            position: absolute;
            right: 0.5rem;
            top: 0;
            bottom: 0;
            margin: auto;

            @media (min-width: 576px) {
               width: 4px;
               height: 70%;
               border-radius: 10px;
               border-bottom-right-radius: 0;
               border-top-right-radius: 0;
            }
         }
      }
   }
   .segment-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: 1rem;

      @media (min-width: 576px) {
         margin-top: 0;
      }
      .segment-container {
         display: flex;
         flex-direction: column;
         margin-bottom: 1rem;

         .segment-informations {
            width: auto;
            display: flex;
            flex-direction: column;
            background: #f3f3f3;
            border-radius: 12px;
            border: 1px solid #cccccc;
            position: relative;
            padding: 1rem 0;
            @media (min-width: 576px) {
               flex-direction: row;
               margin-left: 1rem;
            }

            .segment-informations-inner-wrapper {
               display: flex;
               flex-direction: row;
               width: 100%;
               justify-content: space-around;
               border-right: 1px solid #ccc;

               @media (min-width: 576px) {
                  width: 60%;
               }

               .departure,
               .arrival {
                  display: flex;
                  flex-direction: column;

                  @media (min-width: 576px) {
                     width: 20%;
                  }
                  @media (min-width: 768px) {
                     width: 30%;
                  }
                  @media (min-width: 1200px) {
                     width: 30%;
                  }

                  span {
                     @media (min-width: 1200px) {
                        white-space: nowrap;
                     }

                     &.airport-name-abbr {
                        font-size: var(--large);
                        font-weight: 600;
                     }
                     &.airport-name-full {
                        font-size: var(--small);
                     }
                     &.flight-date {
                        font-size: var(--small);
                        opacity: 0.6;
                     }
                  }
               }

               .flight-info {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  width: 20%;

                  img {
                     width: 50px;
                     height: 50px;
                  }

                  .flight-code {
                     font-size: var(--small);
                     font-weight: 600;
                     margin-top: 0.5rem;
                  }
                  span.flight-operated-airline {
                     font-weight: 400;
                     font-size: var(--xsmall);
                     color: #ff4c4c;
                     text-align: center;
                     max-width: 100px;
                  }
                  .airline-name {
                     font-size: var(--small);
                     opacity: 0.6;
                  }
               }
            }
            .segment-extra-informations-inner-wrapper {
               display: flex;
               flex-direction: column;
               width: 100%;
               justify-content: space-around;
               align-items: center;
               border-top: 1px solid #ccc;

               padding: 2rem;
               margin-top: 1rem;
               padding-top: 1rem;
               padding-bottom: 0rem;

               .segment-extra-informations-inner-wrapper-upper {
                  display: flex;
                  width: 100%;
                  justify-content: space-between;
               }
               .segment-extra-informations-inner-wrapper-footer {
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  justify-content: flex-start;
               }

               @media (min-width: 576px) {
                  width: 40%;
                  border-top: none;
                  margin-top: 0;
                  padding-top: 0;
               }

               .info-box {
                  display: flex;
                  flex-direction: column;

                  .info-title {
                     font-size: var(--small);
                     opacity: 0.8;
                     white-space: nowrap;
                  }
                  .info-content {
                     font-size: var(--large);
                     font-weight: 600;
                  }

                  &:last-child {
                     // width: 60%;
                  }
                  .brand-ssr-toggler {
                     display: flex;
                     align-items: center;
                     background-color: #dbf2ff;
                     color: #007abc !important;
                     width: -moz-fit-content;
                     width: fit-content;
                     border-radius: 0.25rem;
                     font-weight: 600 !important;
                     padding: 0.125rem 0.5rem;
                     cursor: pointer;
                     div {
                        // background-color: #007abc;
                        width: 24px;
                        height: 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 0.125rem;
                        margin-left: 0.45rem;
                        i {
                           &.up {
                              transform: rotate(90deg);
                           }
                           &.down {
                              transform: rotate(-90deg);
                           }

                           transform: scale(0.85);
                           // filter: brightness(100);
                           filter: brightness(0) saturate(100%) invert(35%) sepia(75%) saturate(1352%) hue-rotate(174deg) brightness(87%) contrast(101%);
                        }
                     }
                  }
               }
            }

            .segment-color {
               position: absolute;
               width: 5px;
               right: 0;
               top: 10%;
               bottom: 10%;
               border-top-left-radius: 12px;
               border-bottom-left-radius: 12px;
               background-color: transparent !important;
            }
         }

         &:last-child {
            margin-bottom: 0rem;
         }
      }
   }
}
</style>
